export const FingerEnum = {
    RIGHT_THUMB: 1,
    RIGHT_INDEX: 2,
    RIGHT_MIDDLE: 3,
    RIGHT_RING: 4,
    RIGHT_PINKY: 5,
    LEFT_THUMB: 6,
    LEFT_INDEX: 7,
    LEFT_MIDDLE: 8,
    LEFT_RING: 9,
    LEFT_PINKY: 10,
    get: {
        1: { id: 1, name: 'pulgar', hand: 'derecho' },
        2: { id: 2, name: 'índice', hand: 'derecho' },
        3: { id: 3, name: 'dedo medio', hand: 'derecho' },
        4: { id: 4, name: 'anular', hand: 'derecho' },
        5: { id: 5, name: 'meñique', hand: 'derecho' },
        6: { id: 6, name: 'pulgar', hand: 'izquierdo' },
        7: { id: 7, name: 'índice', hand: 'izquierdo' },
        8: { id: 8, name: 'dedo medio', hand: 'izquierdo' },
        9: { id: 9, name: 'anular', hand: 'izquierdo' },
        10: { id: 10, name: 'meñique', hand: 'izquierdo' }
    }
}



// WEBPACK FOOTER //
// ./src/app/authentication-rnec/fingers.enum.ts